import { makeStyles, tokens } from "@fluentui/react-components";

export const useStyles = makeStyles({
    wrapper: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: tokens.spacingHorizontalS,
    },
    value: {
        whiteSpace: 'nowrap',
        color: tokens.colorNeutralForeground1,
    },
    triggerButton: {
        minWidth: 'auto',
    },
    popoverSurface: {
        borderRadius: tokens.borderRadiusMedium,
        border: `1px solid ${tokens.colorNeutralStroke1}`,
        boxShadow: tokens.shadow16,
    },
    popoverContent: {
        display: 'flex',
        flexDirection: 'column',
        gap: tokens.spacingVerticalM,
    },
    loadingStatus: {
        display: 'flex',
        alignItems: 'center',
        gap: tokens.spacingHorizontalS,
        color: tokens.colorNeutralForeground2,
    },
    footer: {
        display: 'flex',
        justifyContent: 'flex-end',
        paddingTop: tokens.spacingVerticalXS,
    },
});